const questionsModels = [
  {
    // 1
    label: 'What sex were you at birth?',
    field: 'wlGenderIdentify',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'female',
          value: 'Biologically born Female'
        },
        {
          key: 'male',
          value: 'Biologically born Male'
        }
      ]
    }
  }, //1

  {
    // 2
    label: 'If you have answered biologically born female are you:',
    field: 'wlCisgenderWoman',
    type: 'info',
    required: false,
    answer: {
      type: 'list',
      items: [
        {
          label: 'Pregnant ?',
          type: 'single_select',
          options: [
            { key: 'yesPregnant', value: 'Yes' },
            { key: 'noPregnant', value: 'No' }
          ]
        },
        {
          label: 'Trying to Conceive ?',
          type: 'single_select',
          options: [
            { key: 'yesConceive', value: 'Yes' },
            { key: 'noConceive', value: 'No' }
          ]
        },
        {
          label: 'Breastfeeding ?',
          type: 'single_select',
          options: [
            { key: 'yesBreastfeeding', value: 'Yes' },
            { key: 'noBreastfeeding', value: 'No' }
          ]
        }
      ]
    }
  }, //2

  {
    // 3
    label: 'What is your:',
    field: 'wlwWhatisWeightHeight',
    type: 'info',
    required: false,
    answer: {
      type: 'bmi',
      showLabel: true,
      bmiLabel: 'BMI',
      heightLabel: 'Height',
      weightLabel: 'Weight'
    }
  }, //3
  {
    // 4
    label: '',
    field: 'wlPantSize',
    type: 'info',
    required: false,
    answer: {
      type: 'list',
      required: false,
      items: [
        {
          label: 'What is your pant size ?',
          type: 'number',
          name: 'pantSize',
          placeholder: 'What is your pant size?'
        },
        {
          label: 'What is your waist circumference ?',
          type: 'number',
          name: 'waistCircumference',
          placeholder: 'What is your waist circumference?',
          required: false
        },
        {
          label: 'What is your neck size ?',
          type: 'number',
          name: 'neckSize',
          placeholder: 'What is your neck size?',
          required: false
        }
      ]
    }
  }, //4

  {
    //5
    // Education Slide
    field: 'educationSlide1',
    type: 'info',
    educationalSlide:
      "Next let's review any contraindications to medications. If you do have any firm contraindications, the consultation will stop and our medical team will contact you to get a full history, we'll only proceed with medication therapy if we can determine if it will be safe for you to do." +
      '\n\n' +
      " Your genetics can contribute significantly to your weight. Some studies estimate 25-80% of your weight dictated by your DNA. We'll uncover what role your family history can play and then help provide ways to tackle.",
    label: '',
    answer: {}
  }, //5
  // Education Slide

  {
    // 6
    label: 'What are your weight loss goals? Choose all that apply.',
    field: 'wlWLGoals',
    tooltip: [
      {
        title: 'Why we are asking?',
        info: "We ask because it'll help our experts curate the content we share with you. As well as keep track to make sure we're helping you reach your goals!",
        lineBreak: true
      }
    ],
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'energy', value: 'Have more energy' },
        { key: 'behealthier', value: 'Be healthier for my family / my kids' },
        { key: 'confidence', value: 'Improve my confidence' },
        { key: 'fitClothes', value: 'Fit better in my clothes' },
        { key: 'qualityLife', value: 'Improve my quality of life' },
        { key: 'healthConcerns', value: 'Tackle health concerns' },
        {
          key: 'other',
          value: 'Other',
          answer: {
            type: 'text',
            name: 'wlOtherDesc',
            placeholder: 'Please specify'
          }
        }
      ]
    }
  }, //6

  {
    //7
    label: 'When trying to lose weight I like to…',
    field: 'wlILikeTo',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'allIn', value: 'Go all in with exercise and nutrition' },
        {
          key: 'takeMytime',
          value:
            'Take my time with making changes to my nutrition and exercise habit'
        },
        {
          key: 'reduceCal',
          value:
            'Not make any changes to my food choices and just reduce my calories'
        },
        {
          key: 'noChanges',
          value:
            'Not make any changes to my eating habits and exercise/ increase physical activity level to more than usual'
        },
        {
          key: 'focusNut',
          value:
            'Not make any changes to my exercise/physical activity level and focus on my nutrition'
        }
      ]
    }
  },

  {
    label:
      'What are some of the barriers you face when trying to lose and maintain weight?',
    field: 'wlBarriers',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'skipmeals', value: 'Skipping meals/ forgetting to eat' },
        { key: 'emotional', value: 'Emotional eating' },
        { key: 'boredom', value: 'Boredom eating' },
        { key: 'stress', value: 'Stress eating' },
        { key: 'sleep', value: 'Lack of sleep' },
        { key: 'cravings', value: 'Cravings' },
        { key: 'motivation', value: 'Lack of motivation' },
        { key: 'lastMin', value: 'Last minute meal decisions' },
        { key: 'dislikeCooking', value: 'A dislike for cooking' },
        { key: 'cookingSkills', value: 'Lack of cooking skills' },
        { key: 'lackExercise', value: 'Lack of exercise' },
        { key: 'gym', value: 'Not knowing what to do in the gym' },
        { key: 'job', value: 'Sedentary job' },
        { key: 'injury', value: 'Past injury' },
        { key: 'pain', value: 'Chronic pain' },
        { key: 'mental', value: 'Mental health condition' },
        { key: 'overeating', value: 'Overeating' },
        { key: 'snacks', value: 'Grazing on snacks' },
        { key: 'picky', value: 'Picky eating' },
        { key: 'mindless', value: 'Mindless eating' },
        { key: 'medication', value: 'Medication-related weight gain' },
        { key: 'medical', value: 'Medical-condition-related weight gain' },
        { key: 'eatOut', value: 'Eating out take out often' },
        {
          key: 'condition',
          value:
            'Navigating food choices with a health condition diagnosis (e.g. celiac disease)'
        },
        {
          key: 'other',
          value: 'Other',
          answer: {
            type: 'text',
            name: 'wlOtherbarrier',
            placeholder: 'Please specify'
          }
        }
      ]
    }
  },
  {
    label:
      'If you were to pick 1 area of your life that you believe to be contributing to your weight would it be:',
    field: 'wlArea',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'portionControl',
          value: 'portion control - "I am eating too much"'
        },
        {
          key: 'insulin',
          value:
            'insulin resistance - "I am hungry often and don`t stay full for long"'
        },
        {
          key: 'emotional',
          value:
            'emotional eating/ binge eating - "I eat to help regulate my emotions"'
        },
        {
          key: 'exercise',
          value: 'exercise and fitness - "I don`t move my body enough"'
        },
        { key: 'notSure', value: 'not sure' },
        {
          key: 'other',
          value: 'Other',
          answer: {
            type: 'text',
            name: 'wlOtherArea',
            placeholder: 'Please specify'
          }
        }
      ]
    }
  },
  {
    //7
    label: 'Which of the following best describes you? Choose all that apply.',
    field: 'wlDecribesYou',
    tooltip: [
      {
        title: 'Why we are asking?',
        info: 'Some ethnicities have certain health challenges that are more common versus other groups. This helps us identify any extra health concerns that need to be considered.',
        lineBreak: true
      }
    ],
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'white', value: 'White' },
        { key: 'hispanicOrLatino', value: 'Hispanic or Latino' },
        { key: 'american', value: 'Black or African American' },
        { key: 'asian', value: 'Southeast Asian' },
        { key: 'arab', value: 'Middle Eastern or Arab' },
        { key: 'nativeAmerican', value: 'Indigenous' },
        { key: 'mixedEthnicity', value: 'Mixed Ethnicity' },
        { key: 'notListed', value: 'A race/ethnicity not listed here' },
        { key: 'preferToNotAnswer', value: 'Prefer to not answer' }
      ]
    }
  }, //7

  {
    //8
    // Education Slide
    field: 'educationSlide2',
    type: 'info',
    educationalSlide:
      "Now that you have added your basic demographic information, let’s talk about your weight loss journey. It's not only about hitting a number on a scale but more so how you can lose weight and then maintain it sustainably. On average, patients on this program lose about 10% of their body weight after 6 months. Even better: with just 5% weight loss, your risk of developing health concerns like diabetes goes down considerably. People tend to sleep better, have more energy and confidence goes up.",
    label: '',
    answer: {}
  }, //8
  // Education Slide

  {
    // this is duplicated w/ #16
    //9
    // Education Slide3
    field: 'educationSlide3',
    type: 'info',
    educationalSlide:
      'Our medical team can prescribe a range of safe and effective medications. \n\n Some work on the reward center of your brain to curb cravings for certain foods. Other medications help stabilize blood sugar, shrink your appetite, or help you feel more satisfied with less food.',
    label: '',
    answer: {}
  }, //9
  // Education Slide
  {
    // 10
    label: 'Do you have any allergies (Food, Seasonal, Environmental)?',
    field: 'wlallergies',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yesallergies',
          value: 'Yes',
          answer: {
            type: 'list',
            items: [
              {
                type: 'text',
                name: 'toWhat',
                placeholder: 'To what'
              },
              {
                type: 'text',
                name: 'reaction',
                placeholder: 'What is the reaction?'
              }
            ]
          }
        },
        { key: 'noallergies', value: 'No' }
      ]
    }
  }, //10

  {
    // 11
    label:
      'Does anyone in your immediate family have any health conditions? If so, what are/were they?',
    field: 'wlFamilyHealthCondition',
    type: 'select',
    required: false,
    answer: {
      type: 'multi_select',
      required: false,
      options: [
        {
          key: 'mother',
          value: 'Mother',
          answer: {
            type: 'list',
            required: false,
            items: [
              {
                type: 'text',
                name: 'addMother',
                required: false,
                placeholder: 'Please list health conditions'
              }
            ]
          }
        },
        {
          key: 'father',
          value: 'Father',
          answer: {
            type: 'list',
            required: false,
            items: [
              {
                type: 'text',
                name: 'addFather',
                required: false,
                placeholder: 'Please list health conditions'
              }
            ]
          }
        },
        {
          key: 'brother',
          value: 'Brother',
          answer: {
            type: 'list',
            required: false,
            items: [
              {
                type: 'text',
                name: 'addBrother',
                required: false,
                placeholder: 'Please list health conditions'
              }
            ]
          }
        },
        {
          key: 'sister',
          value: 'Sister',
          answer: {
            type: 'list',
            required: false,
            items: [
              {
                type: 'text',
                name: 'addSister',
                required: false,
                placeholder: 'Please list health conditions'
              }
            ]
          }
        },
        {
          key: 'noneFamilyHealth',
          value: 'None of the above',
          uncheckOthers: true
        }
      ]
    }
  }, //11

  {
    // 12
    label: 'Does anyone in your family have a history of:',
    field: 'wlFamilyHistory',
    type: 'select',
    required: false,
    answer: {
      type: 'multi_select',
      options: [
        { key: 'thyroidCancer', value: 'Thyroid Cancer' },
        { key: 'parathyroidCancer', value: 'Parathyroid Cancer' },
        { key: 'adrenalTumourCancer', value: 'Adrenal Tumour/Cancer' },
        { key: 'menSyndrome', value: 'MEN Syndrome' },
        {
          key: 'noneFamilyHistory',
          value: 'None of the above',
          uncheckOthers: true
        }
      ]
    }
  }, //12

  {
    //13
    // Education Slide
    field: 'educationSlide4',
    type: 'info',
    educationalSlide:
      'Sometimes our weight needs to be addressed at a cellular level. The next section will help us determine if prescription medication could help remove what’s been stopping you from sustainable, long term weight loss. Our medical team can prescribe a range of safe and effective medications.' +
      +'\n\n' +
      'Some work on the reward center of your brain to curb cravings for certain foods. Other medications help stabilize blood sugar, shrink your appetite, or help you feel more satisfied with less food.',
    label: '',
    answer: {}
  }, //13
  // Education Slide

  {
    // 14
    label: 'A few questions about your sleep:',
    field: 'wlYourSleep',
    type: 'info',
    required: true,
    answer: {
      type: 'list',
      required: true,
      items: [
        {
          label: 'How long is your sleep on an average night?',
          field: 'sleepQuality',
          type: 'single_select',
          required: true,
          options: [
            { key: 'sleepQualityLessThan7', value: '<7 hours' },
            { key: 'sleepQuality7Or9', value: '7-9 hours' },
            { key: 'sleepQualityMoreThan9', value: '>9 hours' }
          ]
        },
        {
          label: 'Do you snore loudly?',
          field: 'snoreLoudly',
          type: 'single_select',
          required: true,
          options: [
            { key: 'snoreLoudlyYes', value: 'Yes' },
            { key: 'snoreLoudlyNo', value: 'No' }
          ]
        },
        {
          label: 'Do you often feel tired, fatigued or sleepy during the day?',
          type: 'single_select',
          required: true,
          options: [
            { key: 'sleepyYes', value: 'Yes' },
            { key: 'sleepyNo', value: 'No' }
          ]
        },
        {
          label:
            'Has anyone ever said you stopped breathing during your sleep?',
          type: 'single_select',
          required: true,
          options: [
            { key: 'stopBreathingYes', value: 'Yes' },
            { key: 'stopBreathingNo', value: 'No' }
          ]
        },
        {
          label: 'When do you usually go to bed?',
          type: 'text',
          required: true,
          name: 'gotoBed'
        },
        {
          label: 'When do you usually wake up?',
          type: 'text',
          required: true,
          name: 'wakeuptime'
        }
      ]
    }
  }, //14

  {
    // 15
    label: "We're going to ask you a little bit about your mood and outlook.",
    field: 'wlMood',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: "How often do you feel like you're in a gloomy or sad mood?",
          type: 'single_select',
          required: true,
          options: [
            { key: 'gloomyNever', value: 'Never' },
            { key: 'gloomyRarely', value: 'Rarely' },
            { key: 'gloomySometimes', value: 'Sometimes' },
            { key: 'gloomyOften', value: 'Often' }
          ]
        },
        {
          label: 'Do you ever think about self-harm?',
          type: 'single_select',
          options: [
            { key: 'selfHarmNever', value: 'Never' },
            { key: 'selfHarmRarely', value: 'Rarely' },
            { key: 'selfHarmSometimes', value: 'Sometimes' },
            { key: 'selfHarmOften', value: 'Often' }
          ]
        },
        {
          label:
            'Have you ever been diagnosed with, or treated for, any of the following medical conditions?',
          type: 'single_select',
          options: [
            { key: 'treatedSuicide', value: 'Suicide attempts/ideation' },
            { key: 'treatedAnorexia', value: 'Anorexia or bulimia' },
            { key: 'treatedDepression', value: 'Depression' },
            { key: 'treatedAnxiety', value: 'Anxiety' },
            { key: 'treatedNone', value: 'None' }
          ]
        }
      ]
    }
  }, //15
  {
    label: 'Do you have a fear of needles?',
    field: 'wlfearNeedles',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'fear',
          value: 'Yes'
        },
        {
          key: 'noFear',
          value: 'No'
        }
      ]
    }
  },

  {
    //16
    // Education Slide
    field: 'educationSlide3',
    type: 'info',
    educationalSlide:
      'What you eat can impact your mood, energy level, body composition, health, and more! It is important that we understand the ins and outs of what you usually eat on a daily basis. The following questions will help the dietitians complete a thorough analysis of your nuitritional needs. Please note that it is not possible to get all of your nutrition assessment done during this questionnaire, and we will likely need to gather more information in the future to provide you with a more personalized experience.',
    label: '',
    answer: {}
  }, //16
  // Education Slide

  {
    // 17
    label:
      'To build a plan to align with your lifestyle, we need a few more answers about your current habits.',
    field: 'wlCurrentHabits',
    type: 'info',
    required: false,
    answer: {
      type: 'list',
      required: false,
      items: [
        {
          label: 'What is your occupation ?',
          type: 'text',
          name: 'occupation',
          placeholder: 'What is your occupation',
          required: false
        },
        {
          //7
          label: 'What type of work schedule do you have?',
          level: 'child',
          type: 'single_select',
          options: [
            { key: 'fullTime', value: 'full-time, stable' },
            { key: 'partTime', value: 'part-time, stable' },
            { key: 'casual', value: 'Casual' },
            { key: 'fullShift', value: 'full-time, shift work' },
            { key: 'partShift', value: 'part-time, shift work' },
            { key: 'student', value: 'student' },
            { key: 'unemployed', value: 'unemployed' },
            { key: 'homeMaker', value: 'full-time homemaker' },
            { key: 'retired', value: 'retired' }
          ]
        },
        {
          label: 'How many hours a day do you work ?',
          type: 'single_select',
          level: 'child',
          options: [
            { key: 'zeroHour', value: '0' },
            { key: 'oneFiveHour', value: '1-5' },
            { key: 'sixEightHour', value: '6-8' },
            { key: 'moreThanEightHour', value: '8+' }
          ]
        },
        {
          label:
            'How well do you think you are doing with your nutrition? (1 being terrible, 5 being so-so, and 10 being perfect)',
          type: 'number',
          name: 'nutritionScore',
          placeholder: '(1 being terrible, 5 being so-so, and 10 being perfect)'
        },
        {
          label:
            'How confident are you in your willingness, ability, and motivation to improve your nutrition? (1 being not confident at all and 10 being extremely confident)',
          type: 'number',
          name: 'willScore',
          placeholder:
            '(1 being not confident at all and 10 being extremely confident)'
        },
        {
          label: 'How many glasses of water do you usually get in a day?',
          type: 'number',
          name: 'waterCups'
        },
        {
          //7
          label:
            'What beverages do you most commonly consume other than water?',
          level: 'child',
          type: 'multi_select',
          options: [
            {
              key: 'tea',
              value: 'tea (specify what you put in your tea)',
              answer: {
                type: 'text',
                placeholder: 'Please specify',
                name: 'teaSpecify'
              }
            },
            {
              key: 'coffee',
              value: 'Coffee (specify what you put in your coffee)',
              answer: {
                type: 'text',
                placeholder: 'Please specify',
                name: 'coffeeSpecify'
              }
            },
            {
              key: 'decaf',
              value: 'decaf coffee/tea (specify what you put in your coffee)',
              answer: {
                type: 'text',
                placeholder: 'Please specify',
                name: 'decafSpecify'
              }
            },
            { key: 'herbal', value: 'herbal tea' },
            { key: 'juice', value: 'juice' },
            { key: 'dietpop', value: 'diet pop' },
            { key: 'regular pop', value: 'regular pop' },
            { key: 'milk', value: 'milk' },
            {
              key: 'otherDrinks',
              value: 'other',
              answer: {
                type: 'text',
                placeholder: 'Please specify'
              }
            }
          ]
        },
        {
          label:
            'Do you have breakfast ? If yes, What makes up your plate at breakfast (veggies/fruit - protein - starch)? Please breakthem down into percentages adding up to 100%.',
          type: 'single_select',
          options: [
            {
              key: 'breakfastYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'number',
                    name: 'percentVeggiesBreakfast',
                    placeholder: 'xx% veggies/fruit?'
                  },
                  {
                    type: 'number',
                    name: 'percentProteinBreakfast',
                    placeholder: 'xx% protein (eggs, bacon etc.)'
                  },
                  {
                    type: 'number',
                    name: 'percentStarchBreakfast',
                    placeholder:
                      'xx% starch/grain (bread, pancakes, cereal, oatmeal etc.)'
                  }
                ]
              }
            },
            { key: 'Nobreakfast', value: 'No' }
          ]
        },
        {
          label:
            'Do you have lunch ? If yes, What makes up your plate at lunch (veggies/fruit - protein - starch)? Please break them down into percentages adding up to 100%',
          type: 'single_select',
          options: [
            {
              key: 'lunchYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'number',
                    name: 'percentVeggiesLunch',
                    placeholder: 'xx% veggies/fruit?'
                  },
                  {
                    type: 'number',
                    name: 'percentProteinLunch',
                    placeholder: 'xx% protein(tuna, eggs, tempeh etc.)'
                  },
                  {
                    type: 'number',
                    name: 'percentStarchLunch',
                    placeholder: 'xx% starch/grain (bread, quinoa etc.)'
                  }
                ]
              }
            },
            { key: 'NoLunch', value: 'No' }
          ]
        },
        {
          label:
            'Do you have dinner ? If yes, What makes up your plate at dinner (veggies/fruit - protein - starch)? Please break them down into percentages adding up to 100%',
          type: 'single_select',
          options: [
            {
              key: 'dinnerYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'number',
                    name: 'percentVeggiesDinner',
                    placeholder: 'xx% veggies/fruit?'
                  },
                  {
                    type: 'number',
                    name: 'percentProteinDinner',
                    placeholder: 'xx% protein(chicken, fish, tofu etc.)'
                  },
                  {
                    type: 'number',
                    name: 'percentStarchDinner',
                    placeholder:
                      'xx% starch/grain(bread, potatoes, rice, couscous etc.)'
                  }
                ]
              }
            },
            { key: 'NoDinner', value: 'No' }
          ]
        },
        {
          label: 'What are some of your most common snacks?',
          type: 'text',
          name: 'snacksCommon',
          placeholder: 'most common snacks'
        },
        {
          label: 'Do you have any dietary restrictions?',
          level: 'child',
          type: 'multi_select',
          options: [
            { key: 'vegan', value: 'vegan' },
            { key: 'vegetarian', value: 'vegetarian' },
            { key: 'pescitarian', value: 'pescitarian' },
            { key: 'halal', value: 'halal' },
            { key: 'kosher', value: 'kosher' },
            { key: 'allergy', value: 'allergy related' },
            { key: 'celiac', value: 'celiac disease related' },
            { key: 'IBS', value: 'IBS' },
            { key: 'lactose', value: 'lactose intolerance' },
            { key: 'a1', value: 'A1 casein intolerance' },
            { key: 'nightshade', value: 'nightshade intolerance' },
            { key: 'gluten', value: 'gluten intolerance' },
            {
              key: 'otherDrinks',
              value: 'strong food dislikes',
              answer: {
                type: 'text',
                placeholder: 'Please specify'
              }
            },
            {
              key: 'otherDrinks',
              value: 'other',
              answer: {
                type: 'text',
                placeholder: 'Please specify',
                name: 'otherDrinks'
              }
            }
          ]
        },
        /* {
          label:
            'How do you currently keep physically active? This could include specific gym routines, hobbies or non-sedentary movements like yard work.',
          type: 'text',
          name: 'physicallyActive',
          placeholder: 'how do you keep active'
        },

        {
          label:
            'Do you have any injuries or conditions that prevent your body from moving the way you want it to?',
          type: 'text',
          name: 'injuries',
          placeholder: 'any injuries'
        }, */

        {
          label:
            'Considering a 7 day period, how many times on average do you do strenuous, vigorous physical activity (e.g. running, swimming, cycling with vigorous effort), in which your heart is beating rapidly, for more than 15 minutes during your free time? ',
          type: 'number',
          name: '7dayPeriod',
          placeholder: 'how many times a week'
        },
        /* {
          label: 'Do you experience any of the following?',
          type: 'multi_select',
          level: 'child',
          options: [
            { key: 'chestpain', value: 'Unexplained chest pain' },
            { key: 'lowbackpain', value: 'Low back pain' },
            { key: 'joinpain', value: 'Joint pain' },
            { key: 'none', value: 'None' }
          ]
        }, */

        {
          label: 'Do you smoke, if Yes, how many packs a day ?',
          type: 'single_select',
          options: [
            {
              key: 'yesSmoke',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'single_select',
                    halfWidth: true,
                    options: [
                      { key: 'onePacks', value: '1' },
                      { key: 'twoPacks', value: '2' },
                      { key: 'moreThanThreePacks', value: '+3' }
                    ]
                  }
                ]
              }
            },
            { key: 'noSmoke', value: 'No' }
          ]
        },
        {
          label: 'Do you vape, if Yes, how many mL per day ?',
          type: 'single_select',
          options: [
            {
              key: 'yesVape',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'single_select',
                    options: [
                      { key: 'less5mlVape', value: '0-0.5ml' },
                      { key: 'less75mlVape', value: '0.5-0.75ml' },
                      { key: 'moreThan75mlVape', value: '0.75ml +' }
                    ]
                  }
                ]
              }
            },
            { key: 'noVape', value: 'No' }
          ]
        },
        {
          label: 'Do you drink alcohol, if Yes, how often ?',
          type: 'single_select',
          options: [
            {
              key: 'yesAlChohol',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'single_select',
                    options: [
                      { key: 'moreThanOneADay', value: 'more than one a day' },
                      { key: 'oneADay', value: 'one drink a day' },
                      {
                        key: 'oneEveryFewDays',
                        value: 'one drink every few days'
                      },
                      { key: 'onWeekends', value: 'I drink only on weekends' },
                      { key: 'socially', value: 'I only drink socially' },
                      {
                        key: 'rarely',
                        value: 'I rarely drink (less than once a month)'
                      }
                    ]
                  }
                ]
              }
            },
            { key: 'noAlChohol', value: 'No' }
          ]
        },
        {
          label: 'Do you use cannabis, if Yes, how often do you smoke ?',
          type: 'single_select',
          options: [
            {
              key: 'yesCannabis',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'single_select',
                    options: [
                      {
                        key: 'multipleTimesCannabis',
                        value: 'Multiple times a day'
                      },
                      { key: 'dailyCannabis', value: 'daily' },
                      { key: 'weeklyCannabis', value: 'weekly' },
                      { key: 'monthlyCannabis', value: 'monthly' },
                      { key: 'rarelyCannabis', value: 'rarely' }
                    ]
                  }
                ]
              }
            },
            { key: 'noCannabis', value: 'No' }
          ]
        },
        {
          label:
            'Do you use any other street drugs, if yes, how often? what drugs ?',
          type: 'single_select',
          options: [
            {
              key: 'drugsYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'howOftenDrugs',
                    placeholder: 'How often?'
                  },
                  {
                    type: 'text',
                    name: 'whatDrugsDrugs',
                    placeholder: 'What drugs?'
                  }
                ]
              }
            },
            { key: 'drugsNo', value: 'No' }
          ]
        },
        {
          label: 'How would you rate your current general stress level?',
          type: 'single_select',
          level: 'child',
          options: [
            { key: 'notStressed', value: 'Not at all stressed' },
            { key: 'occasionallyStressed', value: 'occasionally stressed' },
            { key: 'moderatelyStressed', value: 'moderately stressed' },
            { key: 'veryStressed', value: 'very stressed' },
            { key: 'alwaysStressed', value: 'always stressed all the time' }
          ]
        },
        /* {
          label:
            'How often do you exercise vigorously for at least 20 minutes?',
          type: 'single_select',
          level: 'child',
          options: [
            {
              key: 'exerciseFiveTimes',
              value: 'I exercise at least 5 times a week'
            },
            {
              key: 'exerciseTwoToFourTimes',
              value: 'I exercise 2-4 times a week'
            },
            { key: 'exerciseOnce', value: 'once a week' },
            { key: 'exerciseRarely', value: 'rarely' }
          ]
        },
        {
          label: 'When thinking about your diet, do you think your diet is:',
          type: 'single_select',
          level: 'child',
          options: [
            {
              key: 'dietNeedToChange',
              value: "Perfect - I don't think I need to change anything"
            },
            {
              key: 'dietUseSomeWork',
              value: 'Average - could use some work and guidance'
            },
            {
              key: 'dietPoor',
              value:
                'Poor - I need lots of help to improve my diet and nutrition.'
            }
          ]
        },
 */
        {
          label: 'What are you most likely to do in your free time?',
          subLabel: 'Select your top 3',
          type: 'multi_select',
          maximumSelectionLength: 3,
          level: 'child',
          options: [
            { key: 'TvMusic', value: 'Watch TV, listen to music ' },
            {
              key: 'sports',
              value: 'Play a sport (e.g. soccer, basketball, squash)'
            },
            {
              key: 'homeImprovement',
              value: 'Gardening, yard work, home improvement'
            },
            {
              key: 'gamesOrReading',
              value: 'Video games/board games, read books'
            },
            {
              key: 'walkBicycleHike',
              value: 'Go for a walk, bicycle, or hike'
            },
            { key: 'socializing', value: 'Socialize with friends/family' },
            { key: 'clubbingOrDancing', value: 'Clubbing, dancing' },
            { key: 'playingWithChildren', value: 'Play with your children' }
          ]
        }
      ]
    }
  }, //17

  {
    // 18
    label:
      'To help find out which medications and supports you are covered for, let us know:',
    field: 'wlCoveredMedications',
    type: 'info',
    required: false,
    answer: {
      type: 'list',
      required: false,
      items: [
        {
          label: 'Do you have private drug coverage?',
          type: 'single_select',
          options: [
            {
              key: 'drugsYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    label: 'Does your plan cover a dietician ?',
                    type: 'single_select',
                    options: [
                      {
                        key: 'yesDietician',
                        value: 'Yes',
                        answer: {
                          type: 'list',
                          items: [
                            {
                              type: 'text',
                              name: 'howMuchDietician',
                              placeholder: 'How much does it cover ?'
                            }
                          ]
                        }
                      },
                      { key: 'noDietician', value: 'No' }
                    ]
                  },
                  {
                    label: 'Does your plan cover a psychologist ?',
                    type: 'single_select',
                    options: [
                      {
                        key: 'yesPsychologist',
                        value: 'Yes',
                        answer: {
                          type: 'list',
                          items: [
                            {
                              type: 'text',
                              name: 'howMuchPsychologist',
                              placeholder: 'How much does it cover ?'
                            }
                          ]
                        }
                      },
                      { key: 'noPsychologist', value: 'No' }
                    ]
                  },
                  {
                    label: 'Does your plan cover in-home nursing ?',
                    type: 'single_select',
                    options: [
                      {
                        key: 'yesHomeNursing',
                        value: 'Yes',
                        answer: {
                          type: 'list',
                          items: [
                            {
                              type: 'text',
                              name: 'howMuchHomeNursing',
                              placeholder: 'How much does it cover ?'
                            }
                          ]
                        }
                      },
                      { key: 'noHomeNursing', value: 'No' }
                    ]
                  }
                ]
              }
            },
            { key: 'drugsNo', value: 'No' }
          ]
        }
      ]
    }
  }, //18

  {
    //19
    // Education Slide
    field: 'educationSlide5',
    type: 'info',
    educationalSlide:
      "Unlike other weight loss methods, our program goes beyond just diet and exercise. or just medication.\n\n We use modern science and proven medicine to craft your plan, and address how genetics, hormones, gut health, sleep quality, and emotional health affects your weight. We're almost done, a few final questions to ensure we create the best program possible.",
    label: '',
    answer: {}
  }, //19
  // Education Slide

  {
    // 20
    label:
      'Have you had any significant weight loss or weight gain in the past six months?',
    field: 'wlLossWeightSixMonth',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yesWeightSixMonth',
          value: 'Yes',
          answer: {
            type: 'list',
            items: [
              {
                type: 'text',
                name: 'lbsWeightSixMonth',
                placeholder: 'How many lbs?'
              }
            ]
          }
        },
        { key: 'noWeightSixMonth', value: 'No' }
      ]
    }
  }, //20

  {
    // 21
    label:
      'Have you tried to lose weight through life modifications (diet) and/or exercise in the past?',
    field: 'wlmodificationsDiet',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yesModificationsDiet',
          value: 'Yes',
          answer: {
            type: 'list',
            items: [
              {
                type: 'text',
                name: 'whatDidYouDoModificationsDiet',
                placeholder: 'What did you do?'
              }
            ]
          }
        },
        { key: 'noModificationsDiet', value: 'No' }
      ]
    }
  }, //21

  {
    // 22
    label: 'What diets have you tried?',
    field: 'wlWhatDiet',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'noneWhatDiet', value: 'None' },
        { key: 'mediterraneanWhatDiet', value: 'Mediterranean' },
        { key: 'dASHWhatDiet', value: 'DASH' },
        { key: 'flexitarianWhatDiet', value: 'The Flexitarian' },
        { key: 'mINDWhatDiet', value: 'MIND' },
        { key: 'mayoClinicWhatDiet', value: 'Mayo Clinic' },
        { key: 'tLCWhatDiet', value: 'TLC' },
        { key: 'volumetricsWhatDiet', value: 'Volumetrics' },
        { key: 'wwWhatDiet', value: 'WW (Weight Watchers)' },
        {
          key: 'lowCalorieWhatDiet',
          value: 'Extremely Low Calorie Diet (e.g. Dr Bernstein)'
        },
        { key: 'intermittentFastingWhatDiet', value: 'Intermittent Fasting' },
        {
          key: 'foodDeliveryWhatDiet',
          value: 'Food Delivery (e.g. Jenny Craig)'
        },
        {
          key: 'otherWhatDiet',
          value: 'Other',
          answer: {
            type: 'text',
            name: 'wlOtherDietWhatDiet',
            placeholder: 'Please specify'
          }
        }
      ]
    }
  }, //23

  {
    //24
    // Education Slide
    field: 'educationSlide6',
    type: 'info',
    educationalSlide:
      "Welcome to our Weight Loss Program!  \n\n Thank you for sharing that information. Our program is powered by medicine but customized to you, so we'll review your answers with our medical team to create your personal plan.\n\n After you click the Finish button below, you will be redirected to book a welcome call with one of our wellness team members to welcome you to our program. They are here to answer any questions you have about the program. You will also be emailed a welcome booklet with more information about your next steps!\n\n In the meantime, make sure you us to your safe sender list and check your spam folder for our confirmation email. \n\n Here's to your good health!",
    label: '',
    answer: {}
  }, //24
  // Education Slide
  ///------------------------------
  // below is mostly for the US flow
  ///------------------------------
  //  {
  //   label: 'Why are you interested in GLP-1? (Check all that apply)',
  //   subLabel: 'Check all that apply'
  //   field: 'wlLossInterest',
  //   type: 'select',
  //   answer: {
  //     type: 'multi_select',
  //     options: [
  //       {
  //         key: '10orless',
  //         value: 'Weight loss of 10 pounds or less'
  //       },
  //       {
  //         key: '11to25',
  //         value:
  //           'Weight loss of 11-25 pounds'
  //       },
  //       {
  //         key: '26to50',
  //         value: 'Weight loss of 26- 50 pounds'
  //       },
  //       {
  //         key: '50ormore',
  //         value: 'Weight loss of more than 50 pounds'
  //       },
  //       {
  //         key: 'regulateAppetite',
  //         value: 'Regulate Appetite'
  //       },
  //       {
  //         key: 'lowerBP',
  //         value: 'Lower Blood Pressure and/or Cholesterol'
  //       },
  //       {
  //         key: 'other',
  //         value: 'Other'
  //       }
  //     ]
  //   }
  // },
  {
    field: 'wlPastPrograms',
    label: 'Have you tried any other weight loss programs in the past?',
    type: 'polar_check',
    answer: {
      label:
        'Please explain - what other weight loss programs have you tried in the past?',
      type: 'text',
      name: 'wlPastProgramsDesc',
      placeholder: 'Type here...'
    }
  },
  {
    label: 'Have you ever given yourself an injection?',
    field: 'wlSelfInjection',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    field: 'wlSelfInjectionProblem',
    label: 'Have you ever had problems using injections of any kind?',
    type: 'polar_check',
    answer: {
      label: 'Please explain',
      type: 'text',
      name: 'wlSelfInjectionProblemDesc',
      placeholder: 'Type here...'
    }
  },
  // {
  //   label: 'Have you experienced any of the following symptoms in the past 12 months?',
  //   field: '12monthsSymptoms',
  //   type: 'select',
  //   answer: {
  //     type: 'multi_select',
  //     options: [
  //       {
  //         key: 'fatigue',
  //         value: 'Weakness and fatigue'
  //       },
  //       {
  //         key: 'anemia',
  //         value:
  //           'Anemia'
  //       },
  //       {
  //         key: 'nerve',
  //         value: 'Nerve pain/damage'
  //       },
  //       {
  //         key: 'vision',
  //         value: 'Blurred or disturbed vision'
  //       },
  //       {
  //         key: 'mood',
  //         value: 'Mood swings'
  //       },
  //       {
  //         key: 'mental',
  //         value: 'Decreased mental acuity/reasoning'
  //       },
  //       {
  //         key: 'none',
  //         value: 'None of the above',
  //         uncheckOthers: true
  //       }
  //     ]
  //   }
  // },
  {
    label: 'Which of the following apply to your reproductive status?',
    field: 'reproductiveStatus',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'notPregnant',
          value: 'I am not currently pregnant nor am I breastfeeding'
        },
        {
          key: 'planning',
          value: 'I am planning to become pregnant or breastfeed soon'
        },
        {
          key: 'pregnant',
          value: 'I am currently pregnant or breastfeeding'
        },
        {
          key: 'menopause',
          value: 'I am currently going through menopause'
        },
        {
          key: 'hysterectomy',
          value: 'I had a hysterectomy or I am post-menopausal'
        },
        {
          key: 'none',
          value: 'None of the above'
        },
        {
          key: 'male',
          value: 'I am a Male (Not Applicable)'
        }
      ]
    }
  },
  {
    field: 'wlPregnant',
    label: 'Are you currently pregnant or planning to become pregnant soon?',
    type: 'polar_check',
    answer: {}
  },
  {
    field: 'wlBreastfeeding',
    label: 'Are you currently breastfeeding?',
    type: 'polar_check',
    answer: {}
  },
  {
    field: 'wlIneligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    educationalSlide: '',
    type: 'info',
    isLast: true,
    answer: {}
  },
  {
    field: 'wlMedicalChanges',
    label:
      'Do you currently or have in the past had any of the following conditions?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'gastroparesis', value: 'Gastroparesis' },
        { key: 'inflammatorybowl', value: 'Inflammatory Bowl Disease' },
        { key: 'pancreatitis', value: 'Pancreatitis' },
        { key: 'pancreaticCancer', value: 'Pancreatic Cancer' },
        {
          key: 'hypertrigyceridemia',
          value: 'Hypertrigyceridemia (elevated triglycerides)',
          answer: {
            type: 'radio',
            name: 'hypertrigyceridemiaOver600',
            label: 'Have your triglycerides been over 600 at any point?',
            options: [
              { key: 'hypertrigyceridemiaOver600Yes', value: 'Yes' },
              { key: 'hypertrigyceridemiaOver600No', value: 'No' }
            ]
          }
        },
        {
          key: 'advancedKidney',
          value: 'Advanced Kidney disease',
          answer: {
            type: 'text',
            name: 'advancedKidneyDesc',
            label: 'Please tell us more'
          }
        },
        { key: 'insulinDiabetes', value: 'Insulin-dependent diabetes' },
        { key: 'thyroidCancer', value: 'Thyroid cancer' },
        {
          key: 'familyHistoryThyroidCancer',
          value: 'Family history of thyroid cancer'
        },
        { key: 'MEN2', value: 'Family history of MEN-2 syndrome' },
        {
          key: 'PCOS',
          value: 'PCOS with fertility problems',
          answer: {
            type: 'text',
            name: 'advancedKidneyDesc',
            label: 'Please tell us more'
          }
        },
        { key: 'eatingDisorder', value: 'Eating disorder, past or present' },
        {
          key: 'suicidal',
          value: 'Suicidal thoughts in the past 12 months',
          answer: {
            type: 'text',
            name: 'advancedKidneyDesc',
            label: 'Please tell us more'
          }
        },
        { key: 'anorexia', value: 'Anorexia or bulemia' },
        {
          key: 'noMedicalChanges',
          value: 'None of the above',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    field: 'wlGallbladder',
    label: 'Have you had a gallbladder disease?',
    type: 'polar_check',
    answer: {}
  },
  {
    field: 'wlGastricBypass',
    label: 'Have you had a gastric bypass in the past 6 months?',
    type: 'polar_check',
    answer: {}
  },
  {
    field: 'wlTakingMeds',
    label: 'Have you started taking any of the following medications?',
    subLabel:
      'Insulin, glimepiride (Amaryl), glipizide (Glucotrol and Glucotrol XL), glyburide (Micronase, Glynase, and Diabeta), sitagliptin, saxagliptin, linagliptin, and alogliptin',
    type: 'polar_check',
    answer: {}
  },
  {
    field: 'wlGLP1Meds',
    label:
      'Are you currently, or have you in the past two months, taken any of the following medications?',
    type: 'select',
    required: true,
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'semaglutide',
          value: 'Semaglutide (Ozempic, Wegovy, Rybeisus)',
          answer: {
            type: 'single_select',
            name: 'semaglutideSideEffect',
            halfWidth: false,
            required: true,
            label:
              'Have you experienced side effects from your current medication?',

            options: [
              {
                key: 'yes',
                value: 'Yes',
                answer: {
                  type: 'text',
                  required: true,
                  name: 'semaglutideSideEffectDesc',
                  label:
                    "Please describe the side effect that you've experienced here"
                }
              },
              {
                key: 'semaglutideSideEffectNo',
                value: 'No'
              }
            ]
          }
        },
        {
          key: 'tirzepatide',
          value: 'Tirzepatide (Zepbound, Mounjaro)',
          required: true,
          answer: {
            type: 'single_select',
            name: 'tirzepatideSideEffect',
            halfWidth: true,
            label:
              'Have you experienced side effects from your current medication?',
            required: true,
            options: [
              {
                key: 'tirzepatideSideEffectYes',
                value: 'Yes',
                answer: {
                  type: 'text',
                  name: 'tirzepatideSideEffectDesc',
                  label:
                    "Please describe the side effect that you've experienced here"
                }
              },
              {
                key: 'tirzepatideSideEffectNo',
                value: 'No'
              }
            ]
          }
        },
        { key: 'none', value: 'None of the above', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'wlMedCloseDose',
    label:
      'Which medication and dose most closely matches your most recent dose?',
    type: 'select',
    required: true,
    answer: {
      type: 'single_select',
      options: [
        // WARNING :: The Keys are used in Beluga middleware so must be careful not to change
        { key: 'semaglutide_0.25', value: 'Semaglutide 0.25mg' },
        { key: 'semaglutide_0.5', value: 'Semaglutide 0.5mg' },
        { key: 'semaglutide_1', value: 'Semaglutide 1mg' },
        { key: 'semaglutide_1.7', value: 'Semaglutide 1.7mg' },
        { key: 'semaglutide_2.4', value: 'Semaglutide 2.4mg' },
        { key: 'tirzepatide_2.5', value: 'Tirzepatide 2.5mg' },
        { key: 'tirzepatide_5', value: 'Tirzepatide 5mg' },
        { key: 'tirzepatide_7.5', value: 'Tirzepatide 7.5mg' },
        { key: 'tirzepatide_10', value: 'Tirzepatide 10mg' },
        { key: 'tirzepatide_12.5', value: 'Tirzepatide 12.5mg' }
      ]
    }
  },
  {
    field: 'wlContinueTreatment',
    label: 'How would you like to continue your treatment',
    type: 'select',
    required: true,
    answer: {
      type: 'single_select',
      options: [
        // WARNING :: The Keys are used in Beluga middleware so must be careful not to change
        { key: 'same', value: 'Stay at the same dose or equivalent dose' },
        { key: 'increase', value: 'Increase dose' },
        { key: 'decrease', value: 'Decrease dose' }
      ]
    }
  },
  // {
  //   field: 'hospitalizedForMood',
  //   label:
  //     "Have you ever been hospitalized for mood-related issues, such as depression, bipolar disorder, or schizophrenia?",
  //   type: 'polar_check',
  //   answer: {
  //     label:
  //       'Please explain',
  //     type: 'text',
  //     name: 'hospitalizedForMoodDesc',
  //     placeholder: 'Please type here...'
  //   }
  // },
  {
    label:
      'Do you have any personal or family history with any of the following medical conditions?',
    field: 'medicalConditions',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'men2',
          value: 'MEN2 (multiple endocrine neoplasia type 2)'
        },
        {
          key: 'thyroidCancer',
          value: 'Thyroid cancer'
        },
        {
          key: 'pancreatitis',
          value: 'Pancreatitis'
        },
        {
          key: 'none',
          value: 'None of the above',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    // 8
    field: 'additionalDetails',
    label:
      'Is there anything else you want your prescriber to know about your condition or health?',
    type: 'polar_check',
    answer: {
      label: 'Please explain',
      type: 'text',
      name: 'additionalDetailsDesc',
      placeholder: 'Type here...'
    }
  },
  {
    field: 'consentTitration',
    label:
      'I understand a weight loss plan enrolls me into an automated titration schedule, as it is required by the FDA',
    type: 'info',
    answer: {
      type: 'consent-check',
      name: 'consentTitrationCheck',
      required: true
    }
  },
  {
    field: 'wlDoctorQuestion',
    label: 'Do you have any other questions for the doctor?',
    type: 'polar_check',
    answer: {
      label: 'What would you like to ask the doctor?',
      type: 'text',
      name: 'wlDoctorQuestionDesc',
      placeholder: 'Type here...'
    }
  },
  {
    label:
      'Please review and agree to the following breastfeeding/pregnancy precaution',
    field: 'wlPregnancyBrestFeedingConsent',
    type: 'info',
    educationalSlide:
      'Pregnancy and Breastfeeding precaution The FDA says that these medications may pose a risk to the developing fetus (baby) if you get pregnant while taking it. "The pill" (oral contraception) is not enough because this medication can interfere with the effectiveness. For birth control you must use condoms, an IUD, or an implanted device. Official FDA recommendation: For the first month after first starting a weight loss medication, and for the first month after each dose escalation, continue using your oral contraception and add a barrier method of contraception (such as condoms) to prevent pregnancy. Alternatively, you can switch to a non-oral contraceptive method you stop the medication, you must continue using a backup method (like condoms) for two months after stopping to allow the medication to fully leave your system before getting pregnant. Similarly, it is not known to be safe in breastfeeding. If you are breastfeeding, consult your doctor for safe weight loss options',
    answer: {
      type: 'consent-check',
      label:
        "I read the information about this product and accept it's potential side effects",
      name: 'wlPregnancyBrestFeedingConsentCheck',
      required: true
    }
  },
  {
    field: 'wlMedsAllergic',
    label: 'Are you allergic to any of the following?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'ozempic', value: 'Ozempic (Semaglutide)' },
        { key: 'mounjaro', value: 'Mounjaro (Tirzepatide)' },
        { key: 'wegovy', value: 'Wegovy (Semaglutide)' },
        { key: 'zepbound', value: 'Zepbound (Tirzepatide)' },
        { key: 'saxenda', value: 'Saxenda (Liraglutide)' },
        {
          key: 'noMedsAllergies',
          value: 'None of the above',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    label: 'Things to know about your gallbladder',
    field: 'wlGallbladderConsent',
    subLabel:
      'Read the following for more information about this product and its potential side effects.',
    type: 'info',
    educationalSlide: `Gallbladder Disease Information 
    You noted that you have had gallbladder stones, problems, or your gallbladder removed. This medication is still a good option however the primary concern is that this medication can affect the way the body handles fats and bile. Without a gallbladder, the body's ability to store and release bile is altered. Bile is crucial for the digestion and absorption Of fats. This medication may increase the likelihood of gastrointestinal side effects in these individuals because it can alter fat metabolism and bile flow. This can lead to symptoms such as diarrhea and stomach pain. Risks of gallbladder disease and weight loss medication. Additionally, medications that affect digestion and appetite, like this medication, might alter the absorption and metabolism of other nutrients (like fat soluble vitamins such as vitamin A, D, E, and K) and medications. This is particularly important for those without a gallbladder, as their digestive system already operates differently from those With a functioning gallbladder. If you Wish to move forward, it is important to eat smaller and more frequent meals. In addition, to ensure that you're receiving enough vitamins, you should avoid processed foods and eat lots of vegetables, as well as considering the use of a multi-vitamin unless told by your provider to avoid these for other reasons.`,
    required: true,
    answer: {}
  }
] as const;

export default questionsModels;
